<button *ngIf="params.data.NumberOfRecords && showViewBtn" class="popup-window" [popover]="popoverTemplate" tabindex="0" container=".cxone-custom-data-import-container"
    containerClass="cxone-popover" placement="left" [outsideClick]="true" id="popup-window-id">
    <svg class="icon-16" id="action-btn-svg">
        <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
    </svg>
</button>

<ng-template #popoverTemplate>
    <div class="more-option-popover cx-one-ui" id="popover">
        <ul class="no-bullets" id="popover-ul">
            <li class="popup" (click)="view()" id="popover-li-1" *ngIf="showViewBtn && params.data.NumberOfRecords">
                <div class="icon" id="eye-icon-div">
                    <svg class="icon-16" id="eye-icon-svg">
                        <use href="../App_Themes/CXone/icons/cxone-view.svg#cxone-view"></use>
                    </svg>
                </div>
                <div style="width: 40px;" cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="View" id="view-label">
                    View
                </div>
            </li>
            <li class="popup" [popover]="popoverDeleteTemplate" tabindex="0" container=".cxone-custom-data-import-container" id="popover-li-2"
            containerClass="cxone-popover-delete cxone-contextual-popover" placement="left" *ngIf="showDeleteBtn">
                <div class="icon" id="trash-icon">
                    <svg class="icon-16" id="trash-icon-svg">
                        <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                    </svg>
                </div>
                <div cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Delete" id="delete-label">
                    Delete
                </div>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #popoverDeleteTemplate>
    <div class="close-popover cx-one-ui" id="close-popover-div">
        <div class="close-popover-wrapper" id="close-popover-wrapper-div">
            <div class="inner" id="inner-div" cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Confirm_Delete_Data">Are you
                sure you want to delete this data?</div>
        </div>
        <div class="cxone-contextual-buttons" id="cxone-contextual-buttons-div">
            <button class="cxone-btn btn-secondary btn-medium edit" cvLocalizedText
                langSection="CXone_Custom_Data_Import" langKey="No" id="no-btn">No</button>
            <button class="cxone-btn btn-medium btn-primary btn-bg-is-white delete-btn"
                cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Yes"
                id="yes-btn" (click)="yesBtnClick()">Yes</button>
        </div>
    </div>
</ng-template>
